import { collectionDurationExceedsInterval } from 'components/node_settings/V4EditSettingsModal/CollectionSettingsTab/collectionDurationValidation';
import { lowFrequencyCollectionExceedsLimits } from 'components/node_settings/V4EditSettingsModal/CollectionSettingsTab/lowFrequencyCollectionValidation';
import { V4SensorSettings } from 'custom_hooks/data_hooks/v4_sensor_settings/shared';
import { UseFormReturn, useWatch } from 'react-hook-form';

export function useV4SettingsValidity(form: UseFormReturn<V4SensorSettings>) {
    const [
        samplingFrequencyHz,
        numberOfSamples,
        updateInterval,
        lowFrequencyCollection,
        envelopedData,
    ] = useWatch({
        control: form.control,
        name: [
            'samplingFrequencyHz',
            'numberOfSamples',
            'updateInterval',
            'lowFrequencyCollection',
            'envelopedData',
        ],
    });

    const collectionDurationInvalid = collectionDurationExceedsInterval({
        samplingFrequencyHz,
        numberOfSamples,
        updateInterval,
    });
    const lowFrequencyCollectionInvalid = lowFrequencyCollectionExceedsLimits({
        lowFrequencyCollection,
        primarySamplingFrequencyHz: samplingFrequencyHz,
        primaryNumberOfSamples: numberOfSamples,
        updateInterval,
    });
    const envelopedDataDurationInvalid =
        envelopedData.enabled &&
        collectionDurationExceedsInterval({
            samplingFrequencyHz: envelopedData.samplingFrequencyHz,
            numberOfSamples: envelopedData.numberOfSamples,
            updateInterval,
        });

    return {
        collectionDurationInvalid,
        lowFrequencyCollectionInvalid,
        envelopedDataDurationInvalid,
        updateInterval,
    };
}
